// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"4a895dd4","498":"b6bd0d5e","545":"8c589fbc"}[chunkId] + ".chunk.js";
};